import {
  ARQUEOS_REQUEST, ARQUEOS_SUCCESS, ARQUEOS_FAILURE,
  ARQUEOS_SALES_REQUEST, ARQUEOS_SALES_SUCCESS, ARQUEOS_SALES_FAILURE,
  ARQUEOS_GENERATED_SALES_REQUEST, ARQUEOS_GENERATED_SALES_SUCCESS, ARQUEOS_GENERATED_SALES_FAILURE,
  ARQUEOS_GENERATED_OPERATIONAL_REQUEST, ARQUEOS_GENERATED_OPERATIONAL_SUCCESS, ARQUEOS_GENERATED_OPERATIONAL_FAILURE,
  ARQUEOS_PERSISTED_SALES_REQUEST, ARQUEOS_PERSISTED_SALES_SUCCESS, ARQUEOS_PERSISTED_SALES_FAILURE,
  ARQUEOS_PERSISTED_OPERATIONAL_REQUEST, ARQUEOS_PERSISTED_OPERATIONAL_SUCCESS, ARQUEOS_PERSISTED_OPERATIONAL_FAILURE,
  ARQUEOS_GENERATE_RANGE_REQUEST, ARQUEOS_GENERATE_RANGE_SUCCESS, ARQUEOS_GENERATE_RANGE_FAILURE
} from '../actions/arqueos'

const INITIAL_STATE = {
  arqueos: null,
  arqueo: null,
  arqueosNeedRefresh: false,
  error: null,
  loading: false,
  generatedSalesArqueos: null,
  generatedOperationalArqueos: null,
  generateRangeResult: null
}

const arqueosReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ARQUEOS_REQUEST:
      return {
        ...state,
        arqueosNeedRefresh: false, error: null, loading: true
      }
    case ARQUEOS_SUCCESS:
      return {
        ...state,
        arqueosNeedRefresh: false, arqueos: action.response, error: null, loading: false
      }
    case ARQUEOS_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case ARQUEOS_SALES_REQUEST:
      return {
        ...state,
        arqueosNeedRefresh: false, error: null, loading: true
      }
    case ARQUEOS_SALES_SUCCESS:
      return {
        ...state,
        arqueosNeedRefresh: false, arqueos: action.response, error: null, loading: false
      }
    case ARQUEOS_SALES_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case ARQUEOS_GENERATED_SALES_REQUEST:
      return { ...state, generatedSalesArqueos: null, loading: true, error: null }
    case ARQUEOS_GENERATED_SALES_SUCCESS:
      return { ...state, generatedSalesArqueos: action.response, loading: false, error: null }
    case ARQUEOS_GENERATED_SALES_FAILURE:
      return { ...state, generatedSalesArqueos: null, loading: false, error: action.error }

    // persisted sales (reads new collection only)
    case ARQUEOS_PERSISTED_SALES_REQUEST:
      return { ...state, generatedSalesArqueos: null, loading: true, error: null }
    case ARQUEOS_PERSISTED_SALES_SUCCESS:
      return { ...state, generatedSalesArqueos: action.response, loading: false, error: null }
    case ARQUEOS_PERSISTED_SALES_FAILURE:
      return { ...state, generatedSalesArqueos: null, loading: false, error: action.error }

    case ARQUEOS_GENERATED_OPERATIONAL_REQUEST:
      return { ...state, generatedOperationalArqueos: null, loading: true, error: null }
    case ARQUEOS_GENERATED_OPERATIONAL_SUCCESS:
      return { ...state, generatedOperationalArqueos: action.response, loading: false, error: null }
    case ARQUEOS_GENERATED_OPERATIONAL_FAILURE:
      return { ...state, generatedOperationalArqueos: null, loading: false, error: action.error }

    // persisted operational (reads new collection only)
    case ARQUEOS_PERSISTED_OPERATIONAL_REQUEST:
      return { ...state, generatedOperationalArqueos: null, loading: true, error: null }
    case ARQUEOS_PERSISTED_OPERATIONAL_SUCCESS:
      return { ...state, generatedOperationalArqueos: action.response, loading: false, error: null }
    case ARQUEOS_PERSISTED_OPERATIONAL_FAILURE:
      return { ...state, generatedOperationalArqueos: null, loading: false, error: action.error }

    case ARQUEOS_GENERATE_RANGE_REQUEST:
      return { ...state, generateRangeResult: null, loading: true, error: null }
    case ARQUEOS_GENERATE_RANGE_SUCCESS:
      return { ...state, generateRangeResult: action.response, loading: false, error: null }
    case ARQUEOS_GENERATE_RANGE_FAILURE:
      return { ...state, generateRangeResult: null, loading: false, error: action.error }
    default:
      return state
  }
}

export default arqueosReducer

